<div class="page-title-section row px-3 m-0 mb-3 pt-5 pb-4 flex-column">
  <div class="main-title main-theme-color d-flex justify-content-center text-uppercase text-center text-uppercase" [ngClass]="{'main-title-margin': !activityService?.ConfigSettings?.isMainBannerOn}"
    (click)="filterByVenue = false">
    {{(displayByType === 'venue' ?
  (filterByVenue ? selectedVenueName : 'allVenues') : (displayByType === 'dining' ? 'restaurants' : 'activities')) | translate}}</div>
  <div class="mt-3 sub-title secondary-theme-color d-flex justify-content-center text-center text-uppercase">{{ activityService?.widgetSettings?.HeaderText  || (displayByType === 'activities' || displayByType === 'non_dining' ? 'spendYourDayWithAdventure' : 'chooseYourFineDine') | translate}}
  </div>
</div>

@if (!activityService.loaderRunning && (originalVenueList | checkAcceptReservations) == 0) {
  <ng-container
    *ngTemplateOutlet="noDataTemplate;context:{contentMsg: 'notAcceptingReservations' , parameter : originalVenueList.length > 0 ? originalVenueList[0].PhoneNumber : ''}">
  </ng-container>
}
@if ((originalVenueList | checkAcceptReservations) != 0) {
  <div>
    <div class="container inner-listing-area">
      @if (!activityService.loaderRunning) {
        <div class="d-flex flex-row justify-content-center align-items-center">
          @if (nonDiningVenuesList?.length && (activityService.enableActivities || activityService.enableDining)) {
            <div matRipple matRippleCentered="true"
              class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu" (click)="loadActivitiesOnly=false;filterNonDining()"
              [ngClass]="displayByType =='non_dining' ? 'sub-menu-selection' : 'sub-menu-unselected'">
              <div class="d-flex align-items-center"><mat-icon style="font-size: 21px;" [ngClass]="displayByType =='non_dining' ? 'mat-icon-color' : 'text-mat-icon-color'">stadium</mat-icon></div><div class="d-flex align-items-center">&nbsp;{{'reserveASpot' | translate}}</div>
            </div>
          }
          @if (activityService.enableActivities && hasGroupLessonActivities && (activityService.enableDining || nonDiningVenuesList?.length)) {
            <div matRipple matRippleCentered="true"
              class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu" (click)="loadActivitiesOnly=true;displayByType='activities';"
              [ngClass]="displayByType =='activities' ? 'sub-menu-selection' : 'sub-menu-unselected'">
              <div class="d-flex align-items-center"><mat-icon [ngClass]="displayByType =='activities' ? 'mat-icon-color' : 'text-mat-icon-color'">filter_hdr</mat-icon></div><div class="d-flex align-items-center">&nbsp;{{'Activities' | translate}}</div>
            </div>
          }
          @if (activityService.enableDining && (activityService.enableActivities || nonDiningVenuesList?.length)) {
            <div matRipple matRippleCentered="true"
              class="d-flex text-uppercase activity-title justify-content-center align-items-center cursor sub-menu" (click)="loadActivitiesOnly=false;filterDining()"
              [ngClass]="loadActivitiesOnly === false && displayByType =='dining' ? 'sub-menu-selection' : 'sub-menu-unselected'">
              <div class="d-flex align-items-center"><mat-icon style="font-size: 21px;" [ngClass]="!loadActivitiesOnly && displayByType =='dining' ? 'mat-icon-color' : 'text-mat-icon-color'">restaurant_menu</mat-icon></div><div class="d-flex align-items-center">&nbsp;{{'dining' | translate}}</div>
            </div>
          }
        </div>
      }
      @if (!noDataFound) {
        <div class="row m-0 d-flex flex-wrap toggle-section justify-content-between align-items-center">
          <div class="d-flex flex-wrap align-items-center">
            @if (false) {
              <div class="p-3">
                <mat-button-toggle-group #colorToggle="matButtonToggleGroup" class="text-uppercase"
                  aria-label="Activities Venue Toggle" (change)="toggleActivitiesVenue($event)">
                  <mat-button-toggle checked value="activities">{{'activities' | translate}}</mat-button-toggle>
                  <mat-button-toggle value="venue">{{'venues' | translate}}</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            }
            @if (activityService.ConfigSettings.filterDropDown) {
              <div class="d-flex align-items-center">
                <mat-form-field appearance="outline">
                  <mat-label>{{'filterByVenue' | translate}}</mat-label>
                  <mat-select [(ngModel)]="filteredVenue">
                    <mat-option [value]="'allActivities'" (click)="filterByVenue = false;displayByType='activities'">{{'allActivities' | translate}}
                    </mat-option>
                    @for (venue of venueList; track venue) {
                      <mat-option [value]="venue.RestaurantName" (click)="filterActivitiesByVenue(venue);displayByType='venue'"
                      >{{venue.RestaurantName}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-icon class="activity-view-toggle" (click)="filterByVenue = false;displayByType='activities';filteredVenue='allActivities';">close</mat-icon>
              </div>
            }
            @if ((displayByType =='non_dining' && activityService?.toListOpenActitivitiesList) || (loadActivitiesOnly && (availableActivities.length > 0 || venueBasedActivityList.length > 0)) || (!loadActivitiesOnly && diningSpecialMeals.length > 0) && displayByType === 'activities') {
              <div class="p-3 d-flex flex-wrap align-items-center">
                <mat-form-field class="activity-date-filter" appearance="outline">
                  <mat-label>{{'selectDateRange'| translate}}</mat-label>
                  <mat-date-range-input [rangePicker]="picker" [min]="currentDateTime">
                    <input readonly (dateChange)="updateDateFilterValue()" matStartDate placeholder="{{'startDate' | translate}}" [(ngModel)]="dateFilterStartDate">
                    <input readonly (dateChange)="updateDateFilterValue()" matEndDate placeholder="{{'endDate' | translate}}" [(ngModel)]="dateFilterEndDate">
                  </mat-date-range-input>
                  @if (dateFilterStartDate || dateFilterEndDate) {
                    <mat-icon class="date-picker-filter-clear-icon cursor" matDatepickerToggleIcon
                    (click)="dateFilterStartDate=null;dateFilterEndDate=null;updateDateFilterValue()">clear</mat-icon>
                  }
                  <mat-datepicker-toggle class="activity-date-selector-toggle" matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <mat-form-field class="activity-date-filter p-2" floatLabel="always" appearance="outline">
                  <mat-label>{{'searchActivity' | translate}}</mat-label>
                  <input matInput type="text" [(ngModel)]="searchText">
                  @if (searchText) {
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="searchText=''">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              </div>
            }
          </div>
          @if (widgetConfigurations.ActivityViewType === 2) {
            <div class="p-3 activity-view-toggle d-flex align-items-center">
              <mat-icon class="mat-icon-color" (click)="toggleView=1" [ngClass]="{'activity-view-toggle-active': toggleView === 1}">view_module</mat-icon>
              <mat-icon class="mat-icon-color" (click)="toggleView=0" [ngClass]="{'activity-view-toggle-active': toggleView === 0}">view_headline</mat-icon>
            </div>
          }
        </div>
      }
      @if (noDataFound) {
        <div class="row m-0 p-3 d-flex flex-wrap toggle-section justify-content-between align-items-center">
          <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg: outOfServiceMessage || 'No Activities found!'}"></ng-container>
        </div>
      }
      @if (!noDataFound) {
        <div class="row m-0 d-flex activities-selection"
          [ngClass]="{'flex-wrap': toggleView === 1, 'flex-column': toggleView === 0,'align-items-center': !toggleView && activityService.ConfigSettings.listLeftAlign === false}">
          @if (!activityService.loaderRunning && displayByType === 'activities') {
            <!-- /** 🐞 Bug Fix | Issue: 46606 | Root: Without filtering the activities of open booking  | Fix: Filtered the open booking activities by Open booking lesson type | By: Tharun | Date: 10/11/2025 */ -->
            @for (avlLessons of availableActivities | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate,'searchText': searchText, 'lessonType': LessonTypes.GroupLesson}; track avlLessons) {
              <div [ngClass]="toggleView ? 'col-lg-4 col-md-6 p-3' : 'col-lg-6 col-md-9 col-12 p-3'">
                @if (toggleView) {
                  <ng-container *ngTemplateOutlet="actvitiesDisplayGridTemplate;context:{avlLessons:avlLessons,lessonType: LessonTypes.GroupLesson}"></ng-container>
                }
                @if (!toggleView) {
                  <ng-container *ngTemplateOutlet="actvitiesDisplayListTemplate;context:{avlLessons:avlLessons,lessonType: LessonTypes.GroupLesson}"></ng-container>
                }
              </div>
            }
            <div class="col-12 d-flex justify-content-center">
              <!-- /** 🐞 Bug Fix | Issue: 46606 | Root: Without filtering the activities of open booking  | Fix: Filtered the open booking activities by Open booking lesson type | By: Tharun | Date: 10/11/2025 */ -->
              @if (!availableActivities || (availableActivities | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate,'searchText': searchText, 'lessonType': LessonTypes.GroupLesson}).length === 0) {
                <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Activities found'}"></ng-container>
              }
            </div>
          }
          @if (!activityService.loaderRunning && displayByType === 'venue') {
            @if (!filterByVenue) {
              @if (toggleView) {
                @for (venue of venueList; track venue; let venueIndex = $index) {
                  <div class="col-lg-4 col-md-6 p-3 venue-card">
                    <div class="activity d-flex flex-column" (click)="filterActivitiesByVenue(venue)">
                      <div class="activity-image">
                        <img [src]="venue.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'" (error)="errorImageHandler($event)" />
                      </div>
                      <div class="activity-details col p-0 d-flex flex-column justify-content-between">
                        <div class="p-2 text-uppercase activity-title class-info__detail__location d-flex align-items-center">
                          <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                          &nbsp; {{venue.RestaurantName}}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
              @if (!toggleView) {
                @for (venue of venueList; track venue; let venueIndex = $index) {
                  <div class="col-md-6 col-12 p-3"
                    >
                    <div class="activity-venue-list d-flex flex-row align-items-center" (click)="filterActivitiesByVenue(venue)">
                      @if (activityService.ConfigSettings.showVenueImageInListView) {
                        <div class="activity-venue-list-image">
                          <img [src]="venue.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'" (error)="errorImageHandler($event)" />
                        </div>
                      }
                      <div class="activity-details col p-0 d-flex flex-column justify-content-between">
                        <div class="p-2 text-uppercase activity-title class-info__detail__location d-flex align-items-center">
                          <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                          {{venue.RestaurantName}}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
              @if (!activityService.loaderRunning && (!venueList || venueList?.length === 0)) {
                <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Venue found!'}"></ng-container>
              }
            }
            @if (filterByVenue) {
              @if (widgetConfigurations.FilterByVenue) {
                <div class="col-lg-12 col-md-12 p-3">
                  <span class="back-to-venue" (click)="filterByVenue = false">
                    <mat-icon matTooltip="{{'backToVenueListing'| translate}}">
                      arrow_circle_left
                    </mat-icon>
                    <span class="venue-name main-theme-color">{{'allVenues'| translate}}</span>
                  </span>
                </div>
              }
              <!-- /** 🐞 Bug Fix | Issue: 46606 | Root: Without filtering the activities of open booking  | Fix: Filtered the open booking activities by Open booking lesson type | By: Tharun | Date: 10/11/2025 */ -->
              @for (avlLessons of venueBasedActivityList | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate, 'lessonType': LessonTypes.GroupLesson}; track avlLessons) {
                <div [ngClass]="toggleView ? 'col-lg-4 col-md-6 p-3' : 'col-lg-6 col-md-9 col-12 p-3'">
                  @if (toggleView) {
                    <ng-container *ngTemplateOutlet="actvitiesDisplayGridTemplate;context:{avlLessons:avlLessons}"></ng-container>
                  }
                  @if (!toggleView) {
                    <ng-container *ngTemplateOutlet="actvitiesDisplayListTemplate;context:{avlLessons:avlLessons}"></ng-container>
                  }
                </div>
              }
              <!-- /** 🐞 Bug Fix | Issue: 46606 | Root: Without filtering the activities of open booking  | Fix: Filtered the open booking activities by Open booking lesson type | By: Tharun | Date: 10/11/2025 */ -->
              @if (!venueBasedActivityList || (venueBasedActivityList | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate, 'lessonType': LessonTypes.GroupLesson}).length === 0) {
                <ng-container
                  *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Activities found'}">
                </ng-container>
              }
            }
          }
          <!-- Dining Template -->
          @if (!activityService.loaderRunning && displayByType === 'dining') {
            @for (dining of diningVenuesList; track dining; let venueIndex = $index) {
              @if (toggleView) {
                <div class="col-lg-4 col-md-6 p-3 dining-card">
                  <div class="dining-inner-container d-flex flex-column">
                    <div class="dining-image">
                      <img [src]="dining.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'"
                        (error)="errorImageHandler($event)" />
                      </div>
                      <div class="activity-details col p-4 d-flex flex-column justify-content-between">
                        <div matTooltip="{{dining.RestaurantName | uppercase}}" matTooltipPosition="above"
                          class="p-2 text-uppercase text-center text-truncate dining-title">
                          {{dining.RestaurantName}}
                        </div>
                        <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
                        (click)="clickReserveNow(dining)">{{'reserveNow' | translate}}</div>
                      </div>
                    </div>
                  </div>
                }
                @if (!toggleView) {
                  <div class="col-lg-6 col-md-9 col-12 p-3">
                    <div matTooltip="{{dining.RestaurantName | uppercase}}" matTooltipPosition="above"
                      class="p-3 dining-list dining-list-title text-truncate text-uppercase text-center dining-title"
                      (click)="clickReserveNow(dining)">
                      {{dining.RestaurantName}}
                    </div>
                  </div>
                }
              }
              @if (!activityService.loaderRunning && (!diningVenuesList || diningVenuesList?.length === 0)) {
                <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Dinings found'}"></ng-container>
              }
            }
            <!-- Non Dining Template -->
            @if (!activityService.loaderRunning && displayByType === 'non_dining' && !activityService.toListOpenActitivitiesList) {
              @for (nonDining of nonDiningVenuesList; track nonDining; let venueIndex = $index) {
                @if (toggleView) {
                  <div class="col-lg-4 col-md-6 p-3 dining-card">
                    <div class="dining-inner-container d-flex flex-column">
                      <div class="dining-image">
                        <img [src]="nonDining.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'"
                          (error)="errorImageHandler($event)" />
                        </div>
                        <div class="activity-details col p-4 d-flex flex-column justify-content-between">
                          <div matTooltip="{{nonDining.RestaurantName | uppercase}}" matTooltipPosition="above"
                            class="p-2 text-uppercase text-center text-truncate dining-title">
                            {{nonDining.RestaurantName}}
                          </div>
                          <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
                            (click)="clickReserveNow_NonDining(nonDining)">
                          {{'reserveNow' | translate}}</div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (!toggleView) {
                    <div class="col-lg-6 col-md-9 col-12 p-3">
                      <div matTooltip="{{nonDining.RestaurantName | uppercase}}" matTooltipPosition="above"
                        class="p-3 dining-list dining-list-title text-truncate text-uppercase text-center dining-title"
                        (click)="clickReserveNow_NonDining(nonDining)">
                        {{nonDining.RestaurantName}}
                      </div>
                    </div>
                  }
                }
                @if (!activityService.loaderRunning && (!nonDiningVenuesList || nonDiningVenuesList?.length === 0)) {
                  <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Activities found!'}"></ng-container>
                }
              }
              @if (activityService.toListOpenActitivitiesList && !activityService.loaderRunning && displayByType === 'non_dining') {
                @for (avlLessons of availableActivities | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate,'searchText': searchText, 'lessonType': LessonTypes.OpenBooking}; track avlLessons) {
                  <div [ngClass]="toggleView ? 'col-lg-4 col-md-6 p-3' : 'col-lg-6 col-md-9 col-12 p-3'">
                    @if (toggleView) {
                      <ng-container *ngTemplateOutlet="actvitiesDisplayGridTemplate;context:{avlLessons:avlLessons,lessonType: LessonTypes.OpenBooking}"></ng-container>
                    }
                    @if (!toggleView) {
                      <ng-container *ngTemplateOutlet="actvitiesDisplayListTemplate;context:{avlLessons:avlLessons,lessonType: LessonTypes.OpenBooking}"></ng-container>
                    }
                  </div>
                }
                <div class="col-12 d-flex justify-content-center">
                  @if (!availableActivities || (availableActivities | activityListFilter:{'startDate': dateFilterStartDate,'endDate': dateFilterEndDate,'searchText': searchText, 'lessonType': LessonTypes.OpenBooking}).length === 0) {
                    <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg:'No Activities found'}"></ng-container>
                  }
                </div>
              }
            </div>
            @if (!activityService.loaderRunning && showDiningSpecialMeals && displayByType === 'dining' && !loadActivitiesOnly) {
              <div class="p-2 mx-3 mt-5 d-flex justify-content-center text-uppercase listing-sub-title">
                {{'specialMeals' | translate}}
              </div>
              @if (diningSpecialMeals.length > 0) {
                <div class="d-flex"
                  [ngClass]="{'flex-wrap': toggleView === 1, 'flex-column': toggleView === 0,'align-items-center': !toggleView && activityService.ConfigSettings.listLeftAlign === false}">
                  @for (specialMeal of diningSpecialMeals ; track specialMeal; let venueIndex = $index) {
                    @if (toggleView) {
                      <div class="col-lg-4 col-md-6 p-3 special-meal-card">
                        <div class="dining-inner-container d-flex flex-column">
                          <!-- <div class="dining-image">
                          <img [src]="dining.venueImageUrl" onerror="this.src='./assets/images/defaultImage.png'"
                            (error)="errorImageHandler($event)" />
                          </div> -->
                          <div class="activity-details col p-4 d-flex flex-column justify-content-between">
                            <div matTooltip="{{specialMeal.LessonName | uppercase}}" matTooltipPosition="above"
                              class="p-2 text-uppercase text-center dining-title">
                              {{specialMeal.LessonName}}
                            </div>
                            <div
                              class="p-2 text-uppercase text-center class-info__detail__location d-flex justify-content-center align-items-center">
                              <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                              &nbsp;<span class="text-truncate activity-description-bold">{{specialMeal.venueName}}</span>
                            </div>
                            <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
                            (click)="bookSpecialMeal(specialMeal)">{{'bookTable' | translate}}</div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (!toggleView) {
                      <div class="col-lg-6 col-md-9 col-12 p-3">
                        <div class="p-1 dining-list d-flex flex-column" (click)="bookSpecialMeal(specialMeal)">
                          <div matTooltip="{{specialMeal.LessonName | uppercase}}" matTooltipPosition="above"
                            class="p-1 dining-list-title text-truncate text-uppercase text-center dining-title">
                            {{specialMeal.LessonName}}
                          </div>
                          <div
                            class="p-1 text-uppercase text-center class-info__detail__location d-flex justify-content-center align-items-center">
                            <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                            &nbsp;<span class="text-truncate activity-description-bold">{{specialMeal.venueName}}</span>
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              }
              @if (diningSpecialMeals.length == 0) {
                <ng-container *ngTemplateOutlet="noDataTemplate;context:{contentMsg: ('noSpecialMeal' | translate)}"></ng-container>
              }
            }
          }
        </div>
      </div>
    }
    <ng-template #noDataTemplate let-contentMsg="contentMsg" let-parameter = "parameter">
      <div
        class="col-sm-12 no-slots-message activity-no-data-error activity-description-bolder d-flex justify-content-center align-items-center">
      {{contentMsg | translate}}  {{parameter}}</div>
    </ng-template>

    <ng-template #actvitiesDisplayGridTemplate let-avlLessons="avlLessons" let-lessonType="lessonType">
      <div class="activity activity-card d-flex flex-column">
        <div class="activity-image cursor" (click)="getActivitiesDetails(avlLessons)">
          <img src="{{avlLessons.ImageUrl || './assets/images/defaultImage.png'}}" onerror="this.src='./assets/images/defaultImage.png'" />
        </div>
        <div class="activity-details col p-4 d-flex flex-column justify-content-between">
          <div matTooltip="{{avlLessons.LessonName | uppercase}}" class="text-uppercase text-truncate activity-title">{{avlLessons.LessonName}}</div>
          @if (avlLessons.BaseRate) {
            <div class="activity-description d-flex">
              {{'pricesStartsFrom' | translate}} @if (avlLessons.BaseRate) {
              <strong class="ms-3">
              {{avlLessons?.OperationCurrency}}{{avlLessons.BaseRate | currencyDecimalFormatter}}</strong>
            }
            @if (!avlLessons.BaseRate) {
              <strong>&ensp;{{'-'}}</strong>
            }
          </div>
        }
        <div>
          @if (avlLessons.TimeRemaining && lessonType === LessonTypes.GroupLesson) {
            <div class="activity-description justify-content-center">@if (!avlLessons.Ongoing) {
              <span>{{'startsIn' | translate}}&ensp;</span>
              }<strong>{{avlLessons.TimeRemaining}}</strong></div>
            }
            @if (!avlLessons.TimeRemaining && lessonType === LessonTypes.GroupLesson) {
              <div class="activity-description expired-label">{{'expired' | translate}}</div>
            }
            <!-- Uncomment to Show Sold Out in Future -->
            <!-- <div @if (avlLessons.AvailableSlots === 0) { class="activity-soldout-msg activity-description-bolder justify-content-center">{{'soldOut' | translate}}</div> } -->
          </div>
          <div class="text-uppercase class-info__detail__location activity-title d-flex">
            <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
            &nbsp;<span class="text-truncate">{{avlLessons.venueName}}</span>
          </div>
          <div class="mt-3 p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
          (click)="clickBookNow(avlLessons)">{{'bookNow' | translate}}</div>
        </div>
      </div>
    </ng-template>

    <ng-template #actvitiesDisplayListTemplate let-avlLessons="avlLessons" let-lessonType="lessonType">
      <div class="activity-list activity-card d-flex flex-row">
        @if (activityService.ConfigSettings.showActivityImageInListView) {
          <div class="activity-list-image cursor"
            (click)="getActivitiesDetails(avlLessons)">
            <img src="{{avlLessons.ImageUrl || './assets/images/defaultImage.png'}}" onerror="this.src='./assets/images/defaultImage.png'"/>
          </div>
        }
        <div (click)="clickBookNow(avlLessons)" class="activity-details col p-4 d-flex flex-column justify-content-between">
          <div class="d-flex flex-wrap justify-content-between">
            <div class="p-0 col-lg-7 col-md-7 col-12">
              <div class="pe-5 d-flex">
                <div matTooltip="{{avlLessons.LessonName | uppercase}}" class="text-uppercase activity-title activity-list-title text-truncate">{{avlLessons.LessonName}}</div>
                <mat-icon (click)="getActivitiesDetails(avlLessons);$event.stopPropagation();" class="ms-3 list-info-icon">info</mat-icon>
              </div>
            </div>
            @if (lessonType === LessonTypes.GroupLesson) {
              <div class="p-0 col-lg-5 col-md-5 col-12">
                @if (avlLessons.TimeRemaining) {
                  <div class="activity-description">@if (!avlLessons.Ongoing) {
                    <span>{{'startsIn' | translate}}&ensp;</span>
                    }<strong>{{avlLessons.TimeRemaining}}</strong></div>
                  }
                  @if (!avlLessons.TimeRemaining) {
                    <div class="activity-description expired-label">{{'expired' | translate}}</div>
                  }
                </div>
              }
            </div>
            <div class="d-flex flex-wrap justify-content-between">
              <div class="p-0 col-lg-7 col-md-7 col-12 order-md-1 order-2">
                <div class="p-0 col-12 text-uppercase class-info__detail__location activity-title d-flex align-items-center">
                  <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
                  <div class="pe-5 text-truncate">{{avlLessons.venueName}}</div>
                </div>
              </div>
              @if (avlLessons.BaseRate) {
                <div class="p-0 col-lg-5 col-md-5 col-12 order-md-2 order-1 activity-description">
                  <div><span class="pe-2">{{'pricesStartsFrom' | translate}}</span>
                  @if (avlLessons.BaseRate) {
                    <strong class="ms-3">{{avlLessons?.OperationCurrency}}{{avlLessons.BaseRate | currencyDecimalFormatter}}</strong>
                  }
                  @if (!avlLessons.BaseRate) {
                    <strong>{{'-'}}</strong>
                  }
                </div>
              </div>
            }
          </div>
          <!-- <div class="activity-description d-flex flex-wrap justify-content-between">
          <div><span class="pe-3">Prices starts from</span>
          <strong @if (avlLessons.BaseRate) {>{{avlLessons.BaseRate | currencyDecimalFormatter | currency}}</strong>
          <strong @if (!avlLessons.BaseRate) {>{{'-'}}</strong>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between align-items-center">
        <div class="p-0 col-12 text-uppercase class-info__detail__location activity-title d-flex align-items-center">
          <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
          {{avlLessons.venueName}}
        </div>
      </div> -->
      @if (activityService.ConfigSettings.showBookButtonInListView) {
        <div
          class="p-0 col-12 mt-3 mt-md-0 d-sm-flex justify-content-end" (click)="clickBookNow(avlLessons)">
          <div
            class="activity-book-button d-flex justify-content-center align-items-center activity-book-list-button activity-buttons text-center text-uppercase">
          {{'bookNow' | translate}}</div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #LessonsDetailsDialog>
  <mat-card class="lessons-details-dialog">
    <mat-card-header>
      <mat-card-title>{{'activitiesDetails' | translate }}
        <mat-icon class="dialog-close float-right cursor-pointer material-icons-round" (click)="detailDialogClose()">
          close
        </mat-icon>
      </mat-card-title>
    </mat-card-header>
    <mat-dialog-content>
      <div class="activity-image">
        <img src="{{selectedActivities?.ImageUrl || './assets/images/defaultImage.png'}}" onerror="this.src='./assets/images/defaultImage.png'"/>
      </div>
      <section class="class-info__detail" [ngClass]="{'mt-20':selectedActivities.ImageUrl === ''}">
        <div class="class-info__detail--header">
          <div class="class-info__detail--header-left">
            <h1 class="class-info__detail__name">{{selectedActivities.LessonName}}</h1>
            <div class="class-info__detail__location">
              <mat-icon class="mat-icon-color" aria-hidden="false" aria-label="location">location_on</mat-icon>
              &nbsp;{{selectedActivities.LocationName}}
            </div>
          </div>
          @if (selectedActivities.BaseRate) {
            <div class="class-info__detail--header-right">
              <label for="rate" class="class-info__detail__rate-label">{{'Startingfrom' | translate}}</label>
              <div class="class-info__detail__rate-value">{{selectedActivities?.OperationCurrency}}
                {{selectedActivities.BaseRate | currencyDecimalFormatter}}
              </div>
            </div>
          }
        </div>
        <div class="class-info__detail--content">
          <div class="class-info__detail__item">
            <label for="activity-type" class="class-info__detail__item--label">{{'activityType' | translate}}</label>
            <div class="class-info__detail__item--value">{{selectedActivities.activityType}}</div>
          </div>
          <div class="class-info__detail__item">
            <label for="start-date" class="class-info__detail__item--label">{{'startDate' | translate}}</label>
            <div class="class-info__detail__item--value">{{selectedActivities.StartDate | date:'MM/dd/yyyy'}}</div>
          </div>
          <div class="class-info__detail__item">
            <label for="endDate" class="class-info__detail__item--label">{{'endDate' | translate}}</label>
            <div class="class-info__detail__item--value">{{selectedActivities.EndDate | date:'MM/dd/yyyy'}}</div>
          </div>
          @if (showAvailableSlotCount) {
            <div class="class-info__detail__item">
              <label for="available" class="class-info__detail__item--label">{{'availableSlots' | translate}}</label>
              @if (selectedActivities.ClassType === selectedActivities.Session) {
                <i
                  class="icon-Info class-info__detail__slotInfo" matTooltipPosition="above"
                matTooltip="{{ 'sessionSlotCountInfoMessage' | translate}}"></i>
              }
              <div class="class-info__detail__item--value class-info__detail__item__value-avilable">
                {{selectedActivities.AvailableSlots}}
              </div>
            </div>
          }
          @if (showAvailableSlotCount) {
            <div class="class-info__detail__item class-info__detail__item_last">
              <label for="instructor" class="class-info__detail__item--label">{{'staff' | translate}}</label>
              <div class="class-info__detail__item--value class-info__ellipsis" title="{{selectedActivities.Staffs}}">
              {{selectedActivities.Staffs}}</div>
            </div>
          }
        </div>
        @if (!showAvailableSlotCount || selectedActivities.AvailableSlots === 0) {
          <div
            class="class-info__detail__note">{{'checkAvailabilityOtherDays' |
          translate}}</div>
        }

      </section>
      @if (selectedActivities.Description) {
        <section class="class-info__description">
          <h2 class="heading-secondary">
            {{'description' | translate}}
          </h2>
          <p class="class-info__description-text">
            {{selectedActivities.Description | textCutter: (descriptionReadMoreClicked ? null : textMaxLegth)}}
            @if (selectedActivities.Description.length > textMaxLegth) {
              <span class="class-info__read-more"
                (click)="descriptionReadMoreClicked = !descriptionReadMoreClicked">
                {{descriptionReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
              </span>
            }
          </p>
        </section>
      }
      @if (selectedActivities.safetyInformation) {
        <section class="class-info__description">
          <h2 class="heading-secondary">
            {{'safetyInformation' | translate}}
          </h2>
          <p class="class-info__description-text">
            {{selectedActivities.safetyInformation | textCutter: (safetyInformationReadMoreClicked ? null : textMaxLegth)}}
            @if (selectedActivities?.safetyInformation.length > textMaxLegth) {
              <span class="class-info__read-more"
                (click)="safetyInformationReadMoreClicked = !safetyInformationReadMoreClicked">
                {{safetyInformationReadMoreClicked ? ('readLess' | translate) : ('readMore' | translate)}}
              </span>
            }
          </p>
        </section>
      }
      @if (selectedActivities?.CancellationPolicy) {
        <section class="class-info__description">
          <h2 class="heading-secondary">
            {{'CancellationPolicy' | translate}}
          </h2>
          <p class="class-info__description-text">
            {{selectedActivities?.CancellationPolicy | textCutter: (cancellationPolicyReadMoreCilcked ? null : textMaxLegth)}}
            @if (selectedActivities?.CancellationPolicy.length > textMaxLegth) {
              <span class="class-info__read-more"
                (click)="cancellationPolicyReadMoreCilcked = !cancellationPolicyReadMoreCilcked">
                {{cancellationPolicyReadMoreCilcked ? ('readLess' | translate) : ('readMore' | translate)}}
              </span>
            }
          </p>
        </section>
      }
      <section class="class-info__detail--footer">
        <div class="p-4 activity-book-button activity-buttons d-flex justify-content-center text-uppercase"
        (click)="clickBookNow(selectedActivities);">{{'bookNow' | translate}}</div>
      </section>
    </mat-dialog-content>
  </mat-card>
</ng-template>
